module.exports = __webpack_public_path__ + "img/amazon_logo.f06a9da1.png";